 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"lang-en":"lang-en","lang-es":"lang-es","lang-es_EC":"lang-es_EC"}[chunkId]||chunkId) + "." + {"chunk-01b41cac":"66430d09","chunk-05bd8a34":"6c64c9b7","chunk-09ce73d7":"dceee372","chunk-18bf65f5":"66eda87f","chunk-2dbfa718":"01a33f6e","chunk-0b52c9e0":"5528f683","chunk-0c1dd4e4":"c2e0f635","chunk-10d1b2ed":"29011781","chunk-7b6dbfc3":"aa8d4130","chunk-dc432690":"a66ce7b2","chunk-15477730":"ea10758c","chunk-17290280":"1c4c8d8c","chunk-1a4a2fe4":"08eeb7e0","chunk-1ec679a8":"b9761ebd","chunk-1face103":"37bef123","chunk-296cd937":"e9518d2d","chunk-2a8e73da":"0425e62f","chunk-2bdffdc4":"33495921","chunk-2d0e95df":"91d6c70f","chunk-2d215fa4":"266fc022","chunk-3a39f4fa":"a15d813d","chunk-3e9e36e2":"86b44fd3","chunk-4306a4b4":"1ab540ff","chunk-46dc3387":"706a2f61","chunk-4d058e38":"b378b3df","chunk-586e750a":"3fcc1250","chunk-58b2d136":"1808c73d","chunk-59531ab9":"1b44a9ba","chunk-47d33c0e":"fa286c30","chunk-7bd7ce3f":"1b648459","chunk-5bfcd2d9":"392cd4c8","chunk-6418a2d8":"5c1ac6f6","chunk-6ee3ad92":"7202aa8e","chunk-6f717ead":"36d29fad","chunk-737c195a":"65cd08ff","chunk-78562cab":"c908f270","chunk-7b63e21a":"102c5fa5","chunk-805368c2":"8359dd7d","chunk-9478811c":"9ff8fa53","chunk-9c149102":"cf66ee75","chunk-b05cc328":"546f9439","chunk-d58bc1c2":"fa2c2b00","chunk-e25ab93a":"1b2a50fa","chunk-ec2520c4":"514e43a0","chunk-ec3b8366":"cb6e6622","chunk-ec886728":"61be744c","chunk-fd87f148":"97b8e842","lang-en":"22d5bcf8","lang-es":"e9dc2a2d","lang-es_EC":"712bdf47"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-01b41cac":1,"chunk-05bd8a34":1,"chunk-18bf65f5":1,"chunk-2dbfa718":1,"chunk-0b52c9e0":1,"chunk-0c1dd4e4":1,"chunk-10d1b2ed":1,"chunk-7b6dbfc3":1,"chunk-dc432690":1,"chunk-15477730":1,"chunk-17290280":1,"chunk-1a4a2fe4":1,"chunk-1ec679a8":1,"chunk-1face103":1,"chunk-296cd937":1,"chunk-2a8e73da":1,"chunk-2bdffdc4":1,"chunk-3a39f4fa":1,"chunk-3e9e36e2":1,"chunk-4306a4b4":1,"chunk-46dc3387":1,"chunk-4d058e38":1,"chunk-586e750a":1,"chunk-59531ab9":1,"chunk-47d33c0e":1,"chunk-7bd7ce3f":1,"chunk-5bfcd2d9":1,"chunk-6418a2d8":1,"chunk-6ee3ad92":1,"chunk-6f717ead":1,"chunk-737c195a":1,"chunk-78562cab":1,"chunk-7b63e21a":1,"chunk-805368c2":1,"chunk-9478811c":1,"chunk-9c149102":1,"chunk-b05cc328":1,"chunk-d58bc1c2":1,"chunk-e25ab93a":1,"chunk-ec2520c4":1,"chunk-ec3b8366":1,"chunk-ec886728":1,"chunk-fd87f148":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"lang-en":"lang-en","lang-es":"lang-es","lang-es_EC":"lang-es_EC"}[chunkId]||chunkId) + "." + {"chunk-01b41cac":"7f075e60","chunk-05bd8a34":"2e6ce793","chunk-09ce73d7":"31d6cfe0","chunk-18bf65f5":"4cb17b73","chunk-2dbfa718":"cd0a377b","chunk-0b52c9e0":"0e433876","chunk-0c1dd4e4":"0e433876","chunk-10d1b2ed":"8bc907f7","chunk-7b6dbfc3":"d5a96d6c","chunk-dc432690":"46540b6a","chunk-15477730":"4db14b8f","chunk-17290280":"8097aa7f","chunk-1a4a2fe4":"81ffde33","chunk-1ec679a8":"deeacd05","chunk-1face103":"0e433876","chunk-296cd937":"6d16c77e","chunk-2a8e73da":"860cc6c2","chunk-2bdffdc4":"25c56122","chunk-2d0e95df":"31d6cfe0","chunk-2d215fa4":"31d6cfe0","chunk-3a39f4fa":"39e9d59b","chunk-3e9e36e2":"83f62112","chunk-4306a4b4":"a9d3a1a1","chunk-46dc3387":"0e433876","chunk-4d058e38":"9876beae","chunk-586e750a":"d9126635","chunk-58b2d136":"31d6cfe0","chunk-59531ab9":"c9920dc2","chunk-47d33c0e":"8c5cec5a","chunk-7bd7ce3f":"0e433876","chunk-5bfcd2d9":"83f62112","chunk-6418a2d8":"16cf8843","chunk-6ee3ad92":"ef6479af","chunk-6f717ead":"e68fede1","chunk-737c195a":"cfa4572c","chunk-78562cab":"93459237","chunk-7b63e21a":"90554a38","chunk-805368c2":"6bcd7ade","chunk-9478811c":"0e433876","chunk-9c149102":"c1283fa6","chunk-b05cc328":"59fcaffe","chunk-d58bc1c2":"efeb1256","chunk-e25ab93a":"db86ee9e","chunk-ec2520c4":"bca7642d","chunk-ec3b8366":"0e433876","chunk-ec886728":"987d4056","chunk-fd87f148":"0e433876","lang-en":"31d6cfe0","lang-es":"31d6cfe0","lang-es_EC":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;
 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
